export const JOB_STATUS_VALUES = [
  "New",
  "Draft",
  "Open",
  "On Hold",
  "Filled",
  "Closed",
];

export const JOB_STATUS_OPTIONS = JOB_STATUS_VALUES.map((status) => ({
  value: status,
  label: status,
}));
